import { TimelineObjectType } from "../graphql-gen";

export const timelineObjectStudentNoteTypesWithoutAttendance = [
	TimelineObjectType.StudentAcademicNote,
	TimelineObjectType.StudentBehaviorNote,
	TimelineObjectType.StudentGeneralNote,
	TimelineObjectType.StudentHealthNote,
	TimelineObjectType.StudentIncidentNote,
	TimelineObjectType.StudentInjuryNote,
	TimelineObjectType.StudentMedicationNote,
	TimelineObjectType.StudentSocialEmotionalNote,
];
